export default __webpack_public_path__ + "static/media/step3.773bf810.png";